import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn, Router } from '@angular/router';
import { I18nService } from '../../i18n/i18n.service';
import { PermissionService } from '../../services/permissions/permission.service';
import { ProjectService } from '../../services/project/project.service';

export const permissionGuard: CanActivateFn = async (route) => {
  const permissionService = inject(PermissionService);
  const projectService = inject(ProjectService);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);
  const i18n = inject(I18nService);

  const requiredPermission = route.data?.['permission'];
  if (
    typeof requiredPermission !== 'string' ||
    requiredPermission.trim() === ''
  ) {
    return router.createUrlTree(['/']);
  }

  // Wait for the project to be restored from localStorage before checking
  // permissions, otherwise a direct URL paste will find no active plant and
  // always redirect to the Plants page.
  await projectService.projectReady$;

  await permissionService.refreshPermissionsForActivePlant({ force: true });

  if (permissionService.hasPermission(requiredPermission)) {
    return true;
  }

  snackBar.open(i18n.t('permission_denied'), '', { duration: 3500 });
  return router.createUrlTree(['/']);
};
